export default "__VITE_ASSET__9be2032e__"